import React from "react";

const CategoriaSelector = ({ setCategoria , setCantidadProductosMostrados}) => {
    return (
        <div className="categoria-selector">
            <label htmlFor="categoria">Filtrar por categoría:</label>
            <select id="categoria" onChange={(e) => {setCategoria(e.target.value); setCantidadProductosMostrados(20);}}>
                <option value="">Todas las categorías</option>
                <option value="Combos">Combos</option>
                <option value="Bidon">Bidon</option>
                <option value="Bolsas">Bolsas</option>
                <option value="Litro">Litro</option>
                <option value="Papeles y Rollos">Papeles y Rollos</option>
                <option value="Varios">Varios</option>
            </select>
        </div>
    );
};

export default CategoriaSelector;